import React from "react";
import { useTranslation } from "react-i18next";
import {
  Typography,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
  CircularProgress,
  Box,
} from "@material-ui/core";

const GenerateEnigmaWithAIView = ({
  classes,
  state,
  handleSubmit,
  handleChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <Typography variant="h4" className={classes.title}>
          {t("generate_enigma_with_ai.title")}
        </Typography>

        <form onSubmit={handleSubmit} className={classes.form}>
          <TextField
            className={classes.textField}
            label={t("generate_enigma_with_ai.prompt_label")}
            multiline
            rows={4}
            value={state.prompt}
            onChange={handleChange("prompt")}
            required
          />

          <FormControlLabel
            control={
              <Checkbox
                checked={state.withAIImage}
                onChange={handleChange("withAIImage")}
                color="primary"
              />
            }
            label={t("generate_enigma_with_ai.with_ai_image")}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.button}
            disabled={state.loading}
          >
            {t("generate_enigma_with_ai.generate_button")}
          </Button>
        </form>

        {state.loading && (
          <Box className={classes.loading}>
            <CircularProgress />
          </Box>
        )}

        {state.error && (
          <Typography className={classes.error}>{state.error}</Typography>
        )}

        {state.success && (
          <Typography className={classes.success}>{state.success}</Typography>
        )}
      </div>
    </div>
  );
};

export default GenerateEnigmaWithAIView;
